import React from "react";

export default function NavItem({ item, path, openPath, onHover, onMouseEnter, onMouseLeave }) {
    const isOpen = path.includes(item);

    const localMouseEnter = () => {
        onHover(true);
        if (item.hasChildren) {
            openPath([...item.parents, item]);
        } else if (onMouseEnter) {
            onMouseEnter(item, false);
        }
    };

    const localMouseLeave = () => {
        onHover(false);
        if (item.hasChildren) {
            // For items with children, trigger the delayed clear
            openPath([]);
        } else if (onMouseLeave) {
            // For childless items, immediately clear path
            onMouseLeave(item, false);
        }
    };

    const handleClick = (e) => {
        if (item.hasChildren) {
            openPath([...item.parents, item]);
            // Don't prevent default - let the link work while also opening dropdown
        } else if (item.url && item.url.trim() !== "") {
            // Let default link behavior work for regular navigation items
            // Only prevent default for special cases like dropdowns
            if (e.ctrlKey || e.metaKey || item.target === "_blank") {
                e.preventDefault();
                window.open(item.url, '_blank');
            }
            // For regular clicks, let the browser handle the link normally
        } else {
            // If no URL is set (href="#"), prevent default to avoid scrolling to top
            e.preventDefault();
        }
    };

    return (
        <li
            className={`nav-item ${item.active ? "active" : ""} ${isOpen ? "open" : ""}`}
            onMouseEnter={localMouseEnter}
            onMouseLeave={localMouseLeave}
        >
            <a
                href={item.url && item.url.trim() !== "" ? item.url : "#"}
                className="nav-link"
                onClick={handleClick}
                target={item.target || "_self"} // Add target attribute
                rel={item.target === "_blank" ? "noopener noreferrer" : undefined} // Add rel for security
            >
                {item.name}
            </a>
        </li>
    );
};
